import { Skeleton } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useCreateChartTheme } from '../../../../../theme';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Plugin personalizado para mostrar el total de las 3 categorías de demora por barra
const dataLabelsPlugin = {
  id: 'dataLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.font = '11px Arial';
    ctx.fillStyle = chart.options.plugins.dataLabelsPlugin?.fillStyle || '#000';
    ctx.textBaseline = 'middle';

    // Calcular totales por cada índice (cada barra/delegación)
    const totals = [];
    const numLabels = chart.data.labels.length;

    // Inicializar array de totales
    for (let i = 0; i < numLabels; i++) {
      totals[i] = 0;
    }

    // Sumar valores de todos los datasets para cada índice
    chart.data.datasets.forEach((dataset) => {
      dataset.data.forEach((value, index) => {
        totals[index] += value || 0;
      });
    });

    // Para barras horizontales apiladas, necesitamos encontrar el punto más a la derecha
    chart.data.labels.forEach((label, labelIndex) => {
      const total = totals[labelIndex];

      if (total > 0) {
        let maxX = 0;
        let barY = 0;

        // Encontrar el punto más a la derecha de todos los datasets para esta etiqueta
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          const meta = chart.getDatasetMeta(datasetIndex);
          const bar = meta.data[labelIndex];

          if (bar && dataset.data[labelIndex] > 0) {
            // Para barras horizontales, x es la posición horizontal
            const barRight = bar.x;
            if (barRight > maxX) {
              maxX = barRight;
              barY = bar.y;
            }
          }
        });

        // Dibujar el total al final de la barra apilada completa
        if (maxX > 0) {
          const totalText = total.toLocaleString();
          // Reducir espacio y usar fuente más pequeña para números largos
          const spacing = totalText.length > 6 ? 3 : 5;
          if (totalText.length > 8) {
            ctx.font = '10px Arial';
          }
          ctx.fillText(totalText, maxX + spacing, barY);
          // Restaurar fuente original
          ctx.font = '11px Arial';
        }
      }
    });
  },
};

const OPTIONS = {
  responsive: true,
  indexAxis: 'y',
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 1,
      right: 40,
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: true, // ❌ oculta las líneas verticales
        drawBorder: true,
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false, // ❌ oculta las líneas horizontales
        drawBorder: false,
      },
      ticks: {
        beginAtZero: true,
        maxTicksLimit: 20,
        callback: function (value, index, values) {
          const label = this.getLabelForValue(value);
          if (label) {
            // Convierte a formato de nombres propios
            let formattedLabel = label
              .toLowerCase()
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');

            // Trunca si es muy largo
            if (formattedLabel.length > 15) {
              return formattedLabel.substring(0, 12) + '...';
            }
            return formattedLabel;
          }
          return label;
        },
      },
    },
  },
};

export const GraficoBar = ({ labels, datasets, options, ...props }) => {
  const { chartTheme } = useCreateChartTheme({
    ...OPTIONS,
    ...options,
  });

  return (
    <>
      {labels && datasets && labels.length > 0 && datasets.length > 0 ? (
        <Bar options={chartTheme} data={{ labels, datasets }} plugins={[dataLabelsPlugin]} />
      ) : (
        <Skeleton
          variant='rectangular'
          width={'100%'}
          height={'100%'}
          sx={{ borderRadius: '8px' }}
        />
      )}
    </>
  );
};
